import { useCreateContext, useRecordContext } from "react-admin";
import { type Vehicle } from "../providers/vehiclesProvider";
import { Row } from "./Row";
import BlockIcon from "@mui/icons-material/Block";
import RestoreFromTrashIcon from "@mui/icons-material/RestoreFromTrash";
import LoadingButton from "@mui/lab/LoadingButton";
import { grants } from "../backoffice.access_control";
import { DeleteRecordButton } from "../buttons/DeleteRecordButton";
import { SaveButton2 } from "../buttons/SaveButton2";
import { runSafelyWithServerClient } from "../api/server.api";
import { CloneButton2 } from "../buttons/CloneButton2";
import { englishPlural } from "../utils/englishPlural";
import { useNavigate } from "react-router";

export function VehicleFormToolbar(props: any) {
  const record = useRecordContext<Vehicle>();
  const { defaultTitle: creatingRecord } = useCreateContext();
  const deleted = record?.deleted;
  return (
    <Row
      style={{ display: "flex", justifyContent: "space-between" }}
      sx={{
        alignItems: { xs: "stretch", sm: "center" },
        flexDirection: { xs: "column", sm: "row" },
        gap: { xs: 2, sm: 0 },
        "& > .MuiButton-root": { width: { xs: "100%", sm: "auto" } },
      }}
      {...props}
    >
      {grants.has("Vehicle:edit") ? <SaveButton2 /> : <div />}
      <Row
        spacing={2}
        justifyContent="flex-end"
        alignItems="center"
        sx={{
          width: { xs: "100%", sm: "auto" },
          "& > .MuiButton-root": { flex: { xs: 1, sm: "initial" } },
        }}
      >
        {!deleted && !creatingRecord && grants.has("Vehicle:edit") && <CloneButton2 />}
        {creatingRecord || !grants.has("Vehicle:delete") ? null : deleted ? (
          <_RecoverButton record={record} />
        ) : (
          <_DeleteButton />
        )}
      </Row>
    </Row>
  );
}

function _DeleteButton() {
  const record = useRecordContext<Vehicle>();
  return (
    <DeleteRecordButton
      icon={<BlockIcon />}
      label="Deaktivieren"
      confirmDialogTitle={`${record.name} wirklich deaktivieren?`}
      successMessage={`${record.name} erfolgreich deaktiviert.`}
      onSuccessRedirectTo={`/drivingSchools/${record.drivingSchoolId}/fleet#${englishPlural(record.type)}`}
    />
  );
}

function _RecoverButton({ record }: { record: Vehicle }) {
  const navigate = useNavigate();
  return (
    <LoadingButton
      startIcon={<RestoreFromTrashIcon />}
      variant="contained"
      onClick={async () =>
        runSafelyWithServerClient(
          (serverClient) => serverClient.undeleteVehicle(undefined, { params: { id: record.id } }),
          {
            successMessage: `${record.name} wieder hergestellt.`,
            onSuccess: () => navigate(`/drivingSchools/${record.drivingSchoolId}/fleet#${englishPlural(record.type)}`),
            errorMessage: `Fehler beim Wiederherstellen von ${record.name}.`,
          },
        )
      }
    >
      Wiederherstellen
    </LoadingButton>
  );
}
